import styled from 'styled-components';

export const Nav = styled.ul`
  display: flex;
`;

export const NavBlock = styled.div`
  position: absolute;
  left: -44px;
  top: 0;
  z-index: 1;
`;

export const ServiceNavBlock = styled(NavBlock)`
  left: 0;
  width: 100%;
`;

export const NavItem = styled.li`
  position: relative;
  z-index: 100;
  &:not(:first-child) {
    padding-left: 33px;
  }
  &:not(:last-child) {
    padding-right: 31px;
  }

  &.nav {
    ${NavBlock} {
      visibility: hidden;
      &:hover {
        visibility: visible;
      }
    }
    &:hover {
      ${NavBlock} {
        visibility: visible;
      }
    }
  }
  &:not(:first-child) {
    &::before {
      content: '';
      display: block;

      width: 1px;
      height: 8px;
      background: rgba(244, 246, 249, 0.6);
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      left: 0;
    }
  }
`;

export const NavLink = styled.a.attrs(props => ({
  href: '#'
}))`
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: rgba(19, 238, 179, 1);
    cursor: pointer;
  }
  &.active {
    color: rgba(19, 238, 179, 1);
  }

  > .arrow-down {
    display: block;
    margin-left: 7px;
    width: 8px;
    height: 5px;
  }
`;

export const NavBlockLink = styled(NavLink)``;
